<div class="input-group">
  <input type="button" value="-" class="button-minus" (click)="decrement()">
  <input type="text" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
    name="amount" [(ngModel)]="currentAmount" (change)="checkValue()" class="quantity-field"
    [ngClass]="{'amount-error': counterError}">
  <input type="button" value="+" class="button-plus" (click)="increment()" 
  >
</div>
